import React from "react";

export const FinanceContext = React.createContext({
  selectedScenarioId: "",
  setSelectedScenarioId: () => {},
  selectedScenarioDetail: undefined,
});
